if (!customElements.get('product-delivery-estimate')) {
  class ProductDeliveryEstimate extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.initLazySection();
    }

    initLazySection() {
      this.section = this.closest('.js-product');
      this.datesEl = this.querySelector('.js-delivery-dates');
      this.hintEl = this.querySelector('.js-delivery-hint');

      this.minDays = parseInt(this.dataset.minDays, 10) || 2;
      this.maxDays = parseInt(this.dataset.maxDays, 10) || 3;
      this.cutoffHour = parseInt(this.dataset.cutoffHour, 10);
      this.skipWeekends = this.dataset.skipWeekends === 'true';
      this.locale = this.dataset.locale || 'de-DE';
      this.showWhenUnavailable = this.dataset.showWhenUnavailable === 'true';

      if (this.section) {
        this.section.addEventListener('on:variant:change', this.handleVariantChange.bind(this));
      }

      this.render(this.dataset.variantAvailable === 'true');
    }

    getVariantData() {
      const el = this.querySelector('[type="application/json"]');
      if (!el) return null;
      try { return JSON.parse(el.textContent); } catch { return null; }
    }

    handleVariantChange(evt) {
      if (evt.detail && evt.detail.variant) {
        const data = this.getVariantData();
        const available = data ? data.available : false;
        this.render(available);
      } else {
        this.render(false);
      }
    }

    addBusinessDays(date, businessDays) {
      const d = new Date(date);
      let added = 0;
      while (added < businessDays) {
        d.setDate(d.getDate() + 1);
        const dow = d.getDay();
        if (!this.skipWeekends || (dow !== 0 && dow !== 6)) {
          added += 1;
        }
      }
      return d;
    }

    formatDate(date) {
      return new Intl.DateTimeFormat(this.locale, {
        weekday: 'short',
        day: 'numeric',
        month: 'short'
      }).format(date);
    }

    sameMonth(a, b) {
      return a.getMonth() === b.getMonth() && a.getFullYear() === b.getFullYear();
    }

    render(available) {
      if (!available) {
        if (this.showWhenUnavailable) {
          this.hidden = false;
          this.setAttribute('data-state', 'unavailable');
          this.datesEl.textContent = this.dataset.textUnavailable || '—';
          this.hintEl.textContent = '';
        } else {
          this.hidden = true;
        }
        return;
      }

      this.hidden = false;
      this.setAttribute('data-state', 'available');

      const now = new Date();
      let extraDay = 0;
      if (!isNaN(this.cutoffHour) && now.getHours() >= this.cutoffHour) {
        extraDay = 1;
      }

      const earliest = this.addBusinessDays(now, this.minDays + extraDay);
      const latest = this.maxDays > this.minDays
        ? this.addBusinessDays(now, this.maxDays + extraDay)
        : earliest;

      const sameDay = earliest.getTime() === latest.getTime();

      let html;
      if (sameDay) {
        const prefix = this.dataset.textPrefixSingle || '';
        html = (prefix ? prefix + ' ' : '') + '<strong>' + this.formatDate(earliest) + '</strong>';
      } else {
        const prefix = this.dataset.textPrefixRange || '';
        const connector = this.dataset.textRangeConnector || '–';
        const left = this.formatDate(earliest);
        const right = this.formatDate(latest);
        html = (prefix ? prefix + ' ' : '')
          + '<strong>' + left + '</strong> ' + connector + ' <strong>' + right + '</strong>';
      }

      this.datesEl.innerHTML = html;

      this.hintEl.textContent = this.dataset.textCutoffHint || '';
    }
  }

  customElements.define('product-delivery-estimate', ProductDeliveryEstimate);
}
